"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4581],{

/***/ 68919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.667,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m6.717 11.182-2.6-2.6a.4.4 0 0 1 0-.566l.566-.565a.4.4 0 0 1 .566 0L7 9.202l3.752-3.751a.4.4 0 0 1 .565 0l.566.565a.4.4 0 0 1 0 .566l-4.6 4.6a.4.4 0 0 1-.566 0Z",
    fill: "#fff"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgCheckCircle);

/***/ }),

/***/ 26234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgExclamationTriangle = function SvgExclamationTriangle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.865 12.167a1 1 0 0 1-.866 1.5H3a1 1 0 0 1-.866-1.5L7.134 3.5a1 1 0 0 1 1.732 0l4.999 8.667ZM8 10.375a.958.958 0 1 0 0 1.917.958.958 0 0 0 0-1.917ZM7.09 6.93l.155 2.834a.25.25 0 0 0 .25.236h1.01a.25.25 0 0 0 .25-.236L8.91 6.93a.25.25 0 0 0-.25-.263H7.34a.25.25 0 0 0-.25.263Z",
    fill: "currentColor"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgExclamationTriangle);

/***/ }),

/***/ 81433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgExclamation = function SvgExclamation(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12a9 9 0 0 1-9 9 9 9 0 0 1-9-9c0-4.969 4.03-9 9-9s9 4.031 9 9Zm-9 1.815a1.67 1.67 0 1 0 0 3.338 1.67 1.67 0 0 0 0-3.338Zm-1.316-1.066-.269-4.935a.435.435 0 0 1 .435-.46h2.3c.25 0 .448.21.435.46l-.27 4.935a.435.435 0 0 1-.434.412h-1.762a.435.435 0 0 1-.435-.412Z",
    fill: "currentColor"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgExclamation);

/***/ }),

/***/ 80382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2a6 6 0 1 0 .002 12.002A6 6 0 0 0 8 2Zm0 2.661a1.016 1.016 0 1 1 0 2.033A1.016 1.016 0 0 1 8 4.66Zm1.065 6.436c.16 0 .29-.13.29-.29v-.581a.29.29 0 0 0-.29-.29h-.29v-2.42a.29.29 0 0 0-.291-.29H6.935a.29.29 0 0 0-.29.29v.58c0 .161.13.291.29.291h.29v1.548h-.29a.29.29 0 0 0-.29.29v.582c0 .16.13.29.29.29h2.13Z",
    fill: "currentColor"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgInfoCircle);

/***/ }),

/***/ 24581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Providers": function() { return /* binding */ Providers; },
  "default": function() { return /* binding */ lib_Providers; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(82066);
// EXTERNAL MODULE: ../../node_modules/next-auth/react/index.js
var react = __webpack_require__(23848);
// EXTERNAL MODULE: ../../node_modules/@mantine/styles/esm/theme/MantineProvider.js + 29 modules
var MantineProvider = __webpack_require__(19298);
// EXTERNAL MODULE: ../../node_modules/@mantine/notifications/esm/NotificationsProvider/NotificationsProvider.js + 17 modules
var NotificationsProvider = __webpack_require__(65923);
// EXTERNAL MODULE: ../../packages/design-system/src/index.js
var src = __webpack_require__(73903);
;// CONCATENATED MODULE: ../../packages/ui/src/UIProvider.tsx




var THEME = {
    primaryColor: "green",
    colors: {
        green: [
            "#E0FFEA",
            "#BBFFD1",
            "#95FFB7",
            "#19FF70",
            "#00FF53",
            "#00FF51",
            "#00FF32",
            "#00F12C",
            "#00D226",
            "#00B721", 
        ]
    },
    breakpoints: src.tokens.BREAKPOINTS,
    fontFamily: src.tokens.FONTS.sans,
    // fontSizes: tokens.FONT_SIZES,
    shadows: src.tokens.SHADOWS,
    radius: {
        sm: Number(src.tokens.RADII.sm.replace("px", "")),
        md: Number(src.tokens.RADII.md.replace("px", "")),
        lg: Number(src.tokens.RADII.lg.replace("px", ""))
    }
};
function UIProvider(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MantineProvider/* MantineProvider */.Me, {
        theme: THEME,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationsProvider/* NotificationsProvider */.N, {
            position: "top-right",
            autoClose: 10000,
            children: children
        })
    });
}

// EXTERNAL MODULE: ./src/lib/react-query.ts + 1 modules
var react_query = __webpack_require__(72900);
;// CONCATENATED MODULE: ./src/lib/Providers.tsx





var REFRESH_INTERVAL_SEC = 14.5 * 60; // 30 seconds before session expires
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Providers(param) {
    var children = param.children, pageProps = param.pageProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.SessionProvider, {
        session: pageProps.session,
        refetchInterval: REFRESH_INTERVAL_SEC,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es.QueryClientProvider, {
            client: react_query/* queryClient */.E,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UIProvider, {
                children: children
            })
        })
    });
}
/* harmony default export */ var lib_Providers = (Providers);


/***/ }),

/***/ 72900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ queryClient; }
});

// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(82066);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mantine/notifications/esm/events.js
var events = __webpack_require__(94856);
// EXTERNAL MODULE: ../../packages/design-system/src/index.js
var src = __webpack_require__(73903);
// EXTERNAL MODULE: ../../packages/assets/icons/check-circle.svg
var check_circle = __webpack_require__(68919);
// EXTERNAL MODULE: ../../packages/assets/icons/exclamation.svg
var exclamation = __webpack_require__(81433);
// EXTERNAL MODULE: ../../packages/assets/icons/exclamation-triangle.svg
var exclamation_triangle = __webpack_require__(26234);
// EXTERNAL MODULE: ../../packages/assets/icons/info-circle.svg
var info_circle = __webpack_require__(80382);
;// CONCATENATED MODULE: ../../packages/ui/src/notifications/notifications.tsx







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
var ICON_MAP = {
    neutral: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* default */.Z, {
        className: "text-gray-700"
    }),
    positive: /*#__PURE__*/ (0,jsx_runtime.jsx)(check_circle/* default */.Z, {
        className: "text-success"
    }),
    negative: /*#__PURE__*/ (0,jsx_runtime.jsx)(exclamation/* default */.Z, {
        className: "text-error"
    }),
    warning: /*#__PURE__*/ (0,jsx_runtime.jsx)(exclamation_triangle/* default */.Z, {
        className: "text-warning"
    }),
    info: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* default */.Z, {
        className: "text-blue"
    })
};
var baseStyles = {
    root: {
        alignItems: "start",
        borderRadius: src.tokens.RADII.lg,
        boxShadow: src.tokens.SHADOWS.card,
        padding: 12,
        paddingLeft: 16
    },
    icon: {
        marginRight: 8,
        width: 32,
        height: 32,
        backgroundColor: "unset !important",
        color: "unset !important",
        "& > svg": {
            width: "100%",
            height: "100%"
        }
    },
    title: {
        fontSize: src.tokens.FONT_SIZES.sm,
        color: src.tokens.COLORS.gray[800],
        fontWeight: 500
    },
    description: {
        fontSize: src.tokens.FONT_SIZES.sm,
        color: src.tokens.COLORS.gray[600]
    }
};
var notifications = {
    show: function show(props) {
        (0,events/* showNotification */.c0)(_objectSpread({
            styles: baseStyles,
            icon: ICON_MAP[props.tone]
        }, props));
    },
    update: events/* updateNotification */.wD
};

// EXTERNAL MODULE: ./src/types/errors/SanitizedGQLError.ts
var SanitizedGQLError = __webpack_require__(11603);
;// CONCATENATED MODULE: ./src/lib/react-query.ts
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}




function defaultErrorHandler(error) {
    if (_instanceof(error, SanitizedGQLError/* SanitizedGQLError */.l)) {
        if (error.code === "UNAUTHENTICATED") {
            router_default().push({
                pathname: "/login",
                query: {
                    callbackUrl: (router_default()).asPath
                }
            });
        } else {
            notifications.show({
                tone: "negative",
                title: "Something went wrong...",
                message: error.message
            });
        }
    }
}
var queryClient = new es.QueryClient({
    queryCache: new es.QueryCache({
        onError: defaultErrorHandler
    }),
    mutationCache: new es.MutationCache({
        onError: defaultErrorHandler
    }),
    defaultOptions: {
        queries: {
            retry: 2,
            useErrorBoundary: function(error) {
                return _instanceof(error, SanitizedGQLError/* SanitizedGQLError */.l);
            }
        }
    }
});


/***/ }),

/***/ 11603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ HandledGQLErrorCodes; },
/* harmony export */   "l": function() { return /* binding */ SanitizedGQLError; }
/* harmony export */ });
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent1, args1, Class1) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _wrapNativeSuper(Class2) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class2);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var HandledGQLErrorCodes;
(function(HandledGQLErrorCodes) {
    HandledGQLErrorCodes["UNAUTHENTICATED"] = "UNAUTHENTICATED";
    HandledGQLErrorCodes["FORBIDDEN"] = "FORBIDDEN";
    HandledGQLErrorCodes["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
})(HandledGQLErrorCodes || (HandledGQLErrorCodes = {}));
var DEFAULT_ERROR_MESSAGE = "An unexpected error occurred. Please try again later.";
var ERROR_MESSAGE_MAP = {
    INTERNAL_SERVER_ERROR: DEFAULT_ERROR_MESSAGE,
    UNAUTHENTICATED: "You must be logged in to perform this action.",
    FORBIDDEN: "You do not have permission to perform this action."
};
var SanitizedGQLError = /*#__PURE__*/ function(Error) {
    "use strict";
    _inherits(SanitizedGQLError, Error);
    var _super = _createSuper(SanitizedGQLError);
    function SanitizedGQLError(error) {
        _classCallCheck(this, SanitizedGQLError);
        var _this;
        var code = error[0].extensions.code;
        var _code;
        _this = _super.call(this, (_code = ERROR_MESSAGE_MAP[code]) !== null && _code !== void 0 ? _code : DEFAULT_ERROR_MESSAGE);
        _this.name = "SanitizedGQLError";
        _this.code = code;
        _this.originalMessage = error[0].message;
        return _this;
    }
    var _proto = SanitizedGQLError.prototype;
    _proto.getDetails = function getDetails() {
        return {
            name: this.name,
            code: this.code,
            message: this.message,
            originalMessage: this.originalMessage
        };
    };
    return SanitizedGQLError;
}(_wrapNativeSuper(Error));


/***/ }),

/***/ 84868:
/***/ (function(__unused_webpack_module, exports) {


// Example palette (atlassian): https://atlassian.design/foundations/color
// Potential palette: https://accessiblepalette.com/?lightness=98.2,93.9,86,76,64,54,48,38,27,18&ff1122=0,0&ffa400=0,-10&00ff3f=0,0&589dff=0,0&c8cfde=0,0
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.COLOR_ALIASES = exports.PALETTE = void 0;
// const PALETTE = {
//   transparent: "transparent",
//   current: "currentColor",
//   white: "#fff",
//   black: "#000",
//   neutral: {
//     50: "#f5f6f7", // (Off-white)
//     100: "#edeef0",
//     200: "#e4e5e7",
//     300: "#c9cfd9",
//     400: "#a1a8b6", // (Bluey-gray)
//     500: "#8f97a5",
//     600: "#767e8d",
//     700: "#606d80",
//     800: "#262b33",
//   },
//   green: {
//     50: "#f0fff5", // H 139 L 97%
//     100: "#e5ffed", // H 138 L 95% (Pastel-green)
//     200: "#ccffdb", // H 138 L 90%
//     500: "#00ff51", // H 139 L 50% (Primary-green)
//     600: "#00d544", // H 139 L 42% (Success)
//     700: "#00b339", // H 139 L 35% (Mid-green)
//   },
//   red: {
//     50: "#fff0f1", // H 356 L 97%
//     100: "#ffe6e8", // H 355 L 95% (Pastel-pink)
//     400: "#ff3b49", // H 356 L 62% (red)
//     500: "#ff1122", // H 356 L 53% (Error)
//   },
//   yellow: {
//     50: "#fffaf0", // H 39 L 97%
//     200: "#fff5cc", // H 48 L 90% (Pastel-yellow)
//     400: "#fdc40c", // H 46 L 52% (Yellow)
//     500: "#ffa400", // H 39 L 50% (Warning)
//   },
// ONLY USED FOR BANNER
//   orange: {
//     200: "#ffdfcc", // H 22 L 90% (Pastel-orange)
//     500: "#ff5e00", // H 22 L 50% (Orange)
//   },
// newYellow: {
//   '50': '#FFFAE5',
//   '100': '#FFF4CC',
//   '200': '#FFE599',
//   '300': '#FFD366',
//   '400': '#FFBD33',
//   '500': '#FFA400',
//   '600': '#CC7C00',
//   '700': '#995800',
//   '800': '#663700',
//   '900': '#331A00'
// }
//   blue: {
//     50: "#f0f6ff", // H 216 L 97%
//     100: "#deebff", // H 216 L 94% (Pastel-blue)
//     400: "#589dff", // H 215 L 67% (Blue)
//   },
// ONLY USED FOR BANNER
//   purple: {
//     100: "#e1e2ff", // H 238 L 94% (Pastel-purple)
//     400: "#696cff", // H 239 L 71% (Purple)
//   },
// // } as const;
// const BRAND_COLOR_ALIASES = {
//   "off-white": PALLETE.gray[50],
//   "primary-green": PALLETE.green[500],
//   "mid-green": PALLETE.green[700],
//   "pastel-green": PALLETE.green[100],
//   "brand-yellow": PALLETE.yellow[500],
//   "brand-orange": PALLETE.orange[500],
//   "brand-red": PALLETE.red[400],
//   "brand-pink": PALLETE.red[100],
//   "brand-purple": PALLETE.purple[400],
//   "brand-blue": PALLETE.blue[400],
//   "pastel-yellow": PALLETE.yellow[200],
//   "pastel-orange": PALLETE.orange[200],
//   "pastel-pink": PALLETE.red[100],
//   "pastel-purple": PALLETE.purple[100],
//   "pastel-blue": PALLETE.blue[100],
// } as const;
exports.PALETTE = {
    transparent: "transparent",
    current: "currentColor",
    white: "#fff",
    black: "#000",
    "off-white": "#f5f6f7",
    gray: {
        100: "#edeef0",
        200: "#e4e5e7",
        300: "#c9cfd9",
        400: "#a1a8b6",
        500: "#8f97a5",
        600: "#767e8d",
        700: "#606d80",
        800: "#262b33"
    },
    "primary-green": "#00ff51",
    red: "#ff3b49",
    pink: "#ff838b",
    orange: "#ff5e00",
    yellow: "#fdc40c",
    "mid-green": "#00b339",
    blue: "#589dff",
    purple: "#696cff",
    "pastel-pink": "#ffe6e8",
    "pastel-orange": "#ffdfcc",
    "pastel-yellow": "#fff5cc",
    "pastel-green": "#e5ffed",
    "pastel-blue": "#deebff",
    "pastel-purple": "#e1e2ff",
    success: "#00d544",
    error: "#ff1122",
    warning: "#ffa400"
};
exports.COLOR_ALIASES = {
    "hi-contrast": exports.PALETTE.black,
    "lo-contrast": exports.PALETTE.white,
    surface: exports.PALETTE.white,
    "active-link": exports.PALETTE["mid-green"],
    "secondary-link": exports.PALETTE.gray[400],
    disabled: exports.PALETTE.gray[300]
};


/***/ }),

/***/ 30239:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.BREAKPOINTS = exports.ASPECT_RATIO = exports.SHADOWS = exports.RADII = exports.FONT_WEIGHTS = exports.FONT_SIZES = exports.FONTS = exports.SIZING = exports.SPACING = exports.COLORS = void 0;
var colors_1 = __webpack_require__(84868);
/**
 * Design tokens
 */ exports.COLORS = _objectSpread({}, colors_1.PALETTE, colors_1.COLOR_ALIASES);
exports.SPACING = {
    px: "1px",
    0: "0px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    11: "2.75rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
};
exports.SIZING = _objectSpread({}, exports.SPACING);
exports.FONTS = {
    sans: "Aeonik, system-ui, -apple-system, sans-serif",
    serif: "Georgia, Cambria, 'Times New Roman', Times, serif",
    mono: "Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace"
};
exports.FONT_SIZES = {
    xs: "0.75rem",
    sm: "0.875rem",
    base: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem"
};
exports.FONT_WEIGHTS = {
    normal: 400,
    medium: 500
};
exports.RADII = {
    none: "0",
    sm: "2px",
    md: "5px",
    lg: "10px",
    full: "9999px"
};
exports.SHADOWS = {
    sm: "0 2px 4px 0 rgba(0, 0, 0, 0.1)",
    lg: "0 8px 24px 0 rgba(51, 51, 51, 0.1), 0 8px 12px 0 rgba(0, 255, 81, 0.1)",
    card: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
    none: "none"
};
exports.ASPECT_RATIO = {
    auto: "auto",
    square: "1 / 1",
    display: "4 / 3",
    video: "16 / 9"
};
exports.BREAKPOINTS = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280
};


/***/ }),

/***/ 73903:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
            enumerable: true,
            get: function get() {
                return m[k];
            }
        };
    }
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.tokens = void 0;
var tokens = __importStar(__webpack_require__(30239));
exports.tokens = tokens;


/***/ })

}]);